export default __webpack_public_path__ + "static/media/Spartan.01633446.ttf";